
import realTime from './realtime'
import 'angular-echarts-lite'
import '_lib/infographic'
// import 'easy-pie-chart/dist/angular.easypiechart.min' CDN

export default angular.module('control.lq', [
    realTime,
    'easypiechart',
    'angular-echarts-lite'
]).config(function ($stateProvider) {
    $stateProvider
        .state('lq', {
            url: '/lq',
            abstract: true,
            template: '<main-page material-type="lq"></main-page>',

        })
        .state('lq.transport', {
            url: '/transport',
            abstract: true,
        })
        .state('lq.transport.current', {
            url: '/current',
            //路由到组件写法
            template: '<tra-cur current-work-area="vm.currentWorkArea"    material-type="lq" by-what="byTime">',
            title: '沥青当日分析',
        })
        .state('lq.transport.history', {
            url: '/history',
            template: '<tra-cur current-work-area="vm.currentWorkArea"  material-type="lq" by-what="byDay">',
            title: '沥青历史分析',
        })
}).config(function ($stateProvider) {
    $stateProvider
        .state('lq.mixplant', {
            url: '/mixplant',
            abstract: true,
            resolve: {
                foo: ['$q','$ocLazyLoad', function ($q,$ocLazyLoad) {

                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('./mixplant/index.js');
                        $ocLazyLoad.load({
                            name: 'control.lq.mixplant'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('lq.mixplant.current', {
            url: '/current',
            //路由到组件写法
            template: '<lq-mix current-work-area="vm.currentWorkArea" by-what="byTime"></lq-mix>',
            title: '沥青当日分析',


        })
        .state('lq.mixplant.history', {
            url: '/history',
            template: '<lq-mix current-work-area="vm.currentWorkArea" by-what="byDay"></lq-mix>',
            title: '沥青历史分析',
        })
}).config(function ($stateProvider) {
    $stateProvider
        .state('lq.pave', {
            url: '/pave',
            abstract: true,
            resolve: {
                foo: ['$q','$ocLazyLoad', function ($q,$ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('./pave/index.js');
                        $ocLazyLoad.load({
                            name: 'control.lq.pave'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('lq.pave.current', {
            url: '/current',
            //路由到组件写法
            template: '<lq-pave current-work-area="vm.currentWorkArea" by-what="byTime"></lq-pave>',
            title: '沥青摊铺当日分析',

        })
        .state('lq.pave.history', {
            url: '/history',
            template: '<lq-pave current-work-area="vm.currentWorkArea" by-what="byDay"></lq-pave>',
            title: '沥青摊铺历史分析',
        })
        .state('paveCloudPicture', {
            url:'/paveCloudPicture/:paveCloudPictureRequest',
            template: '<lq-pave-cloud-picture></lq-pave-cloud-picture>'
        })
}).config(function ($stateProvider) {
        $stateProvider
            .state('lq.roll', {
                url: '/roll',
                abstract: true,
                resolve: {
                    foo: ['$q','$ocLazyLoad', function ($q,$ocLazyLoad) {
                        let deferred = $q.defer();
                        require.ensure([], function () {
                            let module = require('./roll/index.js');
                            $ocLazyLoad.load({
                                name: 'control.lq.roll'
                            });
                            deferred.resolve(module);
                        });

                        return deferred.promise;
                    }]
                }
            })
            .state('lq.roll.current', {
                url: '/current',
                //路由到组件写法
                template: '<lq-roll current-work-area="vm.currentWorkArea" by-what="byTime">',
                title: '沥青碾压当日分析'
            })
            .state('lq.roll.history', {
                url: '/history',
                //路由到组件写法
                template: '<lq-roll current-work-area="vm.currentWorkArea" by-what="byDay">',
                title: '沥青碾压历史分析'
            })
            .state('rollCloudPicture', {
                url: '/rollCloudPicture/:rollCloudPictureRequest',
                template: '<lq-roll-cloud-picture></lq-roll-cloud-picture>'
            })
}).config(function ($stateProvider) {
    $stateProvider
        .state('lq.summary', {
            url: '/summary',
            template: '<lq-sum-main current-work-area="vm.currentWorkArea"  ></lq-sum-main>',
            title:'沥青汇总',
            resolve: {
                foo: ['$q','$ocLazyLoad', function ($q,$ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('./summary/index.js');
                        $ocLazyLoad.load({
                            name: 'control.lq.summary'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
}).name
